import { ComponentPropsWithoutRef } from 'react';

import { Link } from './Link';
import { Section } from './Section';
import { Tab, TabLink } from './Tab';
import { Title } from './Title';

import { AppHeaderStyled } from './AppHeader.styles';

export type AppHeaderProps = ComponentPropsWithoutRef<'div'>;

export function AppHeader({ children, ...props }: AppHeaderProps) {
  return (
    <AppHeaderStyled role="presentation" aria-label="application header with menu" {...props}>
      {children}
    </AppHeaderStyled>
  );
}

AppHeader.Section = Section;
AppHeader.Link = Link;
AppHeader.Tab = Tab;
AppHeader.TabLink = TabLink;
AppHeader.Title = Title;
